import ProductCard from "./productCard";

export default ProductCard;